import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
//import { isMobile } from 'react-device-detect';
import isMobile from 'ismobilejs'
import { withRouter } from 'react-router';
import CloseIcon from 'components/icon/Close';

import paths from 'paths';

class MenuButton extends  PureComponent {
    state = { newNotification: false };

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.currentUser.counters) {
            if (this.props.currentUser && this.props.currentUser.counters && prevProps.currentUser.counters.count_notifications !== this.props.currentUser.counters.count_notifications) {
                this.setState({ newNotification: true });
                let timer = setTimeout(() => this.setState({ newNotification: false }, () => timer = null), 5000)
            }
        }
    }

    openNotifications = e => {
        e.preventDefault();
        this.props.history.push(paths.memberNotificationList.path);
    };

    render() {
        const { newNotification } = this.state;
        const { show, currentUser, switchMenu } = this.props;

        let counter;
        if (currentUser && currentUser.counters) {
            counter = currentUser.counters.count_notifications
        }

        const showCounter = isMobile.any && !show && !!counter;

        let classnames = ['icon-menu'];
        if (show) classnames.push('active');
        if (isMobile.any && newNotification) classnames.push('newNotification');
        classnames = classnames.join(' ');

        return (
            <div className={classnames} onClick={newNotification ? this.openNotifications : switchMenu}>
                {showCounter && <div className='counter'>{counter}</div>}
                {show ? <CloseIcon colorIndex="theme"/>: null}
            </div>
        )
    }
}

MenuButton.propTypes = {
    show: PropTypes.bool.isRequired,
    switchMenu: PropTypes.func.isRequired,
    currentUser: PropTypes.object.isRequired,
};

const mapStateToProps = state => {
    return {
        currentUser:  state.currentUser
    }
};

export default withRouter(connect(mapStateToProps)(MenuButton));



// WEBPACK FOOTER //
// ./src/components/menubutton/MenuButton.js